import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Providers from './Providers';
import * as serviceWorker from './registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);

// Disabled service-worker for now because we are not taking advantage
// of offline features and it causes reload issues when updating
serviceWorker.unregister();
